<template>
  <div class="k2" :class="rootClass" :style="rootStyle" :data-w="wc">
    <kds2-bar
      ref="bar"
      :wc="wc"
      :phone="phone"
      :counts="typeCounts"
      :type="type"
      :late-count="lateTotal"
      :only-late="onlyLate"
      :conn="conn"
      :sound="settings.sound"
      :q="q"
      :q-open="qOpen"
      :live="dateMode === 'live'"
      :date-label="dateLabel"
      :clock="clockText"
      :date-text="dateText"
      :subtitle="subtitle"
      :is-admin="isAdmin"
      :rest-label="restLabel"
      :rest-on="!!rest"
      :pop-kind="pop ? pop.kind : ''"
      :fullscreen="fullscreenOn"
      :fullscreen-supported="fullscreenSupported"
      @back="goBack"
      @type="type = $event"
      @late="onlyLate = !onlyLate"
      @q-open="openSearch"
      @q-input="q = $event"
      @q-clear="clearSearch"
      @sound="toggleSound"
      @settings="openSettings"
      @fullscreen="toggleFullscreen"
      @date="togglePop('date', $event)"
      @rest="togglePop('rest', $event)"
    />

    <kds2-banners
      :live="dateMode === 'live'"
      :date-text="pickedDateText"
      :offline="offline"
      :bad="connAge >= staleSeconds"
      :last-ok-text="lastOkText"
      :sound-blocked="soundBlocked"
      @live="goLive"
      @retry="loadTickets"
      @unlock="unlockSound"
    />

    <kds2-board
      ref="board"
      :stages="visibleStages"
      :groups="groups"
      :dens="settings.dens"
      :narrow="wc === 'nr'"
      :current="currentStage"
      :calm="calm"
      :now="viewNow"
      :q="qn"
      :show-rest="showRest"
      :chooser-id="chooserId"
      :last-est="settings.lastEst"
      :new-ids="newIds"
      :filtered="filtered"
      @det="openDetails"
      @go="go"
      @pick="pick"
      @choose-x="closeChooser"
      @more="onMore"
      @status-menu="onStatusMenu"
      @dens="cycleDens"
      @seen="clearNew"
    />

    <kds2-tabs
      v-if="wc === 'nr'"
      :stages="visibleStages"
      :current="currentStage ? currentStage.key : ''"
      :counts="tabCounts"
      :flags="tabFlags"
      @stage="stageSel = $event"
    />

    <kds2-toast :undo="undo" :err="errMsg" :ms="undoMs" @undo="undoLast" />

    <kds2-sheet v-if="sheet === 'set'" :label="tx('set.title')" :return-el="sheetReturn" @close="closeSheet">
      <template #head><h3>{{ tx("set.title") }}</h3></template>
      <kds2-settings
        :settings="settings"
        :wc="wc"
        :live="dateMode === 'live'"
        :wake-supported="wakeSupported"
        :fullscreen-supported="fullscreenSupported"
        @set="onSet"
        @vis="onVis"
        @reset="resetSettings"
        @date="togglePop('date', $event)"
        @fullscreen="toggleFullscreen"
      />
    </kds2-sheet>
    <kds2-sheet v-else-if="sheet === 'det' && detTicket" :label="tx('det.aria', { id: detTicket.id })" :return-el="sheetReturn" @close="closeSheet">
      <template #head>
        <div class="k2-sh-t">
          <span class="k2-sh-type"><k2-icon :n="detMeta.icon" :s="18" />{{ $t(detMeta.labelKey) }}</span>
          <h3>#{{ detTicket.id }} · {{ detTicket.guest }}</h3>
        </div>
      </template>
      <kds2-details :t="detTicket" :now="viewNow" @state="onDetState" @status="onDetStatus" @print="printDetails" />
    </kds2-sheet>

    <kds2-menu
      v-if="menuTicket && !menu.kind"
      :t="menuTicket"
      :anchor="menu.el"
      :confirm="confirmId === menuTicket.id"
      @close="closeMenu(false)"
      @det="onMenuDetails"
      @back-step="onBackStep"
      @hold="onHold"
      @reject-ask="askReject"
      @reject="rejectOrder"
      @reject-no="cancelReject"
    />
    <kds2-status-menu v-else-if="menuTicket" :t="menuTicket" :anchor="menu.el" @close="closeMenu(false)" @pick="onStatusPick" />
    <kds2-date-pop
      v-if="pop && pop.kind === 'date'"
      :anchor="pop.el"
      :live="dateMode === 'live'"
      :date="dateInput"
      :max="todayIso"
      @close="pop = null"
      @live="goLive"
      @pick="pickDate"
      @shift="shiftDate"
    />
    <kds2-rest-pop
      v-if="pop && pop.kind === 'rest'"
      :anchor="pop.el"
      :value="rest"
      :list="restOptions"
      :total="restTotal"
      @close="pop = null"
      @pick="pickRest"
    />

    <div class="k2-live" aria-live="polite">{{ live }}</div>

    <!-- štampa koristi isti ispis kao stari dijalog narudžbe; dijalog se ne prikazuje -->
    <guest-order-details-dialog v-if="detTicket" ref="printer" :value="false" :order="detTicket.raw" :guest="detTicket.rawGuest" />
  </div>
</template>

<script>
import "@/assets/styles/kds2.css";
import K2Icon from "@/components/kds2/K2Icon.vue";
import Kds2Bar from "@/components/kds2/Kds2Bar.vue";
import Kds2Banners from "@/components/kds2/Kds2Banners.vue";
import Kds2Board from "@/components/kds2/Kds2Board.vue";
import Kds2Tabs from "@/components/kds2/Kds2Tabs.vue";
import Kds2Toast from "@/components/kds2/Kds2Toast.vue";
import Kds2Sheet from "@/components/kds2/Kds2Sheet.vue";
import Kds2Settings from "@/components/kds2/Kds2Settings.vue";
import Kds2Details from "@/components/kds2/Kds2Details.vue";
import Kds2Menu from "@/components/kds2/Kds2Menu.vue";
import Kds2StatusMenu from "@/components/kds2/Kds2StatusMenu.vue";
import Kds2DatePop from "@/components/kds2/Kds2DatePop.vue";
import Kds2RestPop from "@/components/kds2/Kds2RestPop.vue";
import GuestOrderDetailsDialog from "@/components/dialogs/GuestOrderDetailsDialog.vue";
import kds2Text from "@/mixins/kds2Text";
import kds2Orders from "@/mixins/kds2Orders";
import kds2Device from "@/mixins/kds2Device";
import {
  SETTINGS_KEY,
  STAGES,
  TH,
  actionOf,
  backOf,
  countLate,
  defaultSettings,
  fmtClock,
  fmtDate,
  loadSettings,
  toISODate,
  typeMeta,
} from "@/utils/kdsTickets";

const NEXT_DENS = { full: "compact", compact: "minimal", minimal: "full" };

// Kuhinjski ekran (/kitchen-display). Plan i obrazloženje: "Dizajn kuhinjskog ekrana.html".
// Podaci i promjene stanja: mixins/kds2Orders, uređaj: mixins/kds2Device (prefiks "kds2" je ostao od probne verzije).
export default {
  name: "KitchenDisplay",
  components: {
    K2Icon,
    Kds2Bar,
    Kds2Banners,
    Kds2Board,
    Kds2Tabs,
    Kds2Toast,
    Kds2Sheet,
    Kds2Settings,
    Kds2Details,
    Kds2Menu,
    Kds2StatusMenu,
    Kds2DatePop,
    Kds2RestPop,
    GuestOrderDetailsDialog,
  },
  mixins: [kds2Text, kds2Orders, kds2Device],
  data() {
    return {
      settings: loadSettings(localStorage),
      type: "all",
      q: "",
      qOpen: false,
      onlyLate: false,
      rest: "",
      stageSel: "pending",
      sheet: null, // "set" | "det"
      detId: null,
      sheetReturn: null,
      chooserId: null,
      menu: null, // { id, el } ili { id, el, kind: "status" } za meni uz strelicu na glavnom dugmetu
      confirmId: null,
      pop: null, // { kind: "date" | "rest", el }
      live: "",
      undoMs: TH.undoMs,
      staleSeconds: TH.staleMs / 1000,
    };
  },
  computed: {
    rootClass() {
      return ["k2--" + this.wc, { "k2--phone": this.phone }];
    },
    rootStyle() {
      return {
        "--ub": this.unit + "px",
        "--u": this.unit * this.settings.font + "px",
        "--bar": (this.phone ? 52 : 56) + "px",
      };
    },
    visibleStages() {
      return STAGES.filter((s) => this.settings.vis[s.key]);
    },
    currentStage() {
      return this.visibleStages.find((s) => s.key === this.stageSel) || this.visibleStages[0] || null;
    },
    filtered() {
      return !!this.qn || this.onlyLate || this.type !== "all";
    },
    // nema nijedne narudžbe i nije ništa izabrano: mirna slika umjesto praznih kolona
    calm() {
      return this.wc !== "nr" && this.dateMode === "live" && !this.filtered && !this.rest && this.tickets.length === 0 && this.loaded;
    },
    showRest() {
      return this.isAdmin && !this.rest;
    },
    todayIso() {
      return toISODate(new Date(this.viewNow));
    },
    clockText() {
      return fmtClock(this.viewNow);
    },
    dateText() {
      return fmtDate(this.viewNow);
    },
    pickedDateText() {
      return this.dateMode === "live" ? "" : fmtDate(new Date(this.customDate + "T00:00:00").getTime());
    },
    dateLabel() {
      return this.dateMode === "live" ? this.$t("last_24h") : this.pickedDateText;
    },
    dateInput() {
      return this.dateMode === "live" ? this.todayIso : this.customDate;
    },
    selectedRest() {
      return this.restOptions.find((o) => String(o.id) === String(this.rest)) || null;
    },
    restLabel() {
      return this.selectedRest ? this.selectedRest.name : this.tx("rest.all");
    },
    restTotal() {
      return this.tickets.length;
    },
    subtitle() {
      if (this.isAdmin) return this.restLabel;
      const name = this.toLatin((this.$store.state.restaurant && this.$store.state.restaurant.name) || "");
      return name || this.$t("kitchen_display_subtitle");
    },
    lastOkText() {
      return this.lastOk ? fmtClock(this.lastOk) : "";
    },
    // veza: Uživo (zeleno), Veza prekinuta (žuto, prvih 30 s), Bez veze (crveno, sa starošću podataka)
    conn() {
      if (!this.offline) {
        const age = Math.min(99, Math.max(0, Math.floor((this.viewNow - this.lastOk) / 1000)));
        const suffix = this.wc === "xl" && this.loaded ? " · " + age + " " + this.tx("unit.s") : "";
        return { cls: "ok", text: this.tx("conn.live") + suffix };
      }
      const age = this.connAge;
      if (age < this.staleSeconds) return { cls: "warn", text: this.tx("conn.broken") };
      const span = age >= 60 ? Math.floor(age / 60) + " " + this.tx("unit.min") : age + " " + this.tx("unit.s");
      return { cls: "bad", text: this.tx("conn.none") + " · " + span };
    },
    // donji tabovi: broj po koloni i oznaka NOVO / kasni
    tabCounts() {
      const counts = {};
      this.visibleStages.forEach((s) => {
        counts[s.key] = this.groups[s.key].length;
      });
      return counts;
    },
    tabFlags() {
      const flags = {};
      this.visibleStages.forEach((s) => {
        const list = this.groups[s.key];
        flags[s.key] = list.some((t) => this.newIds[t.id]) ? "new" : countLate(list, this.viewNow) ? "late" : "";
      });
      return flags;
    },
    detTicket() {
      return this.sheet === "det" ? this.byId(this.detId) : null;
    },
    detMeta() {
      return this.detTicket ? typeMeta(this.detTicket.type) : typeMeta(2);
    },
    menuTicket() {
      return this.menu ? this.byId(this.menu.id) : null;
    },
  },
  mounted() {
    // ekran je tačno veličine prozora; Vuetify inače crta prazan klizač uz desnu ivicu
    this._htmlOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = "hidden";
  },
  beforeDestroy() {
    document.documentElement.style.overflow = this._htmlOverflow || "";
  },
  watch: {
    settings: {
      handler(value) {
        try {
          localStorage.setItem(SETTINGS_KEY, JSON.stringify(value));
        } catch (e) {
          // bez pamćenja podešavanja, ekran radi dalje
        }
      },
      deep: true,
    },
    // narudžba iz otvorenih detalja ili menija je nestala (npr. odbijena): zatvori
    detTicket(t) {
      if (this.sheet === "det" && !t) this.closeSheet();
    },
    menuTicket(t) {
      if (this.menu && !t) this.closeMenu(false);
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: "guest-report" });
    },

    // ---------- fokus ----------
    focusKey(key) {
      this.$nextTick(() => {
        const el = this.$el.querySelector('[data-fk="' + key + '"]');
        if (el) el.focus({ preventScroll: true });
      });
    },
    // kartica prati narudžbu u novu kolonu; ne dira polje za pretragu dok se kuca
    focusCard(id) {
      this.$nextTick(() => {
        const active = document.activeElement;
        if (active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName)) return;
        const el = this.$el.querySelector('.k2c[data-id="' + id + '"]');
        if (el) el.focus({ preventScroll: true });
      });
    },

    // ---------- traka ----------
    openSearch() {
      this.qOpen = true;
      this.$nextTick(() => this.$refs.bar.focusSearch());
    },
    clearSearch() {
      this.q = "";
      this.qOpen = false;
      this.focusKey("qb");
    },
    toggleSound() {
      this.$set(this.settings, "sound", !this.settings.sound);
    },
    togglePop(kind, el) {
      if (this.pop && this.pop.kind === kind) {
        this.pop = null;
        return;
      }
      this.menu = null;
      this.confirmId = null;
      this.pop = { kind, el };
    },
    pickRest(id) {
      this.rest = id;
      this.pop = null;
    },
    goLive() {
      this.dateMode = "live";
      this.pop = null;
      this.sheet = null;
    },
    pickDate(iso) {
      this.customDate = iso;
      this.dateMode = "custom";
      this.pop = null;
      this.sheet = null;
    },
    shiftDate(days) {
      const base = new Date((this.dateMode === "live" ? this.todayIso : this.customDate) + "T00:00:00");
      base.setDate(base.getDate() + days);
      const iso = toISODate(base);
      if (iso >= this.todayIso) this.goLive();
      else {
        this.customDate = iso;
        this.dateMode = "custom";
      }
    },

    // ---------- podešavanja ----------
    openSettings() {
      this.sheetReturn = document.activeElement;
      this.pop = null;
      this.menu = null;
      this.sheet = "set";
    },
    closeSheet() {
      this.sheet = null;
      this.detId = null;
    },
    onSet(key, value) {
      this.$set(this.settings, key, value);
    },
    onVis(key) {
      const on = !this.settings.vis[key];
      if (!on && this.visibleStages.length <= 1) return; // bar jedna kolona ostaje
      this.$set(this.settings.vis, key, on);
    },
    cycleDens(key) {
      this.$set(this.settings.dens, key, NEXT_DENS[this.settings.dens[key]]);
      this.focusKey("dens-" + key);
    },
    resetSettings() {
      const keep = { sound: this.settings.sound, wake: this.settings.wake, lastEst: this.settings.lastEst };
      this.settings = { ...defaultSettings(), ...keep };
    },

    // ---------- detalji ----------
    openDetails(id) {
      if (!this.byId(id)) return;
      this.sheetReturn = document.activeElement;
      this.menu = null;
      this.pop = null;
      this.confirmId = null;
      this.detId = id;
      this.sheet = "det";
    },
    onDetState(to) {
      const t = this.detTicket;
      if (!t || to === this.currentPhase(t)) return;
      if (to === "accepted") {
        // prihvatanje traži procjenu: list se zatvara, a izbor je na kartici
        this.closeSheet();
        this.menu = null;
        this.chooserId = t.id;
        this.focusKey("pick-" + this.settings.lastEst);
        return;
      }
      this.move(t.id, to);
    },
    currentPhase(t) {
      if (t.state === "on-hold") return "pending";
      return t.state === "in-progress" ? "accepted" : t.state;
    },
    onDetStatus(to) {
      const t = this.detTicket;
      if (!t) return;
      this.move(t.id, to);
      this.closeSheet();
    },
    printDetails() {
      const printer = this.$refs.printer;
      if (printer && printer.printOrder) printer.printOrder();
    },

    // ---------- meni kartice ----------
    onMore(id, el) {
      if (this.menu && this.menu.id === id && !this.menu.kind) {
        this.closeMenu(false);
        return;
      }
      this.pop = null;
      this.confirmId = null;
      this.menu = { id, el };
    },
    // strelica uz glavno dugme: bilo koje stanje jednim dodirom (ostalo od ranije ili zaboravljeno)
    onStatusMenu(id, el) {
      if (this.menu && this.menu.id === id && this.menu.kind === "status") {
        this.closeMenu(false);
        return;
      }
      this.pop = null;
      this.confirmId = null;
      this.menu = { id, el, kind: "status" };
    },
    onStatusPick(to) {
      const t = this.menuTicket;
      if (!t) return;
      this.menu = null;
      if (to === "accepted") {
        // prihvatanje traži procjenu: izbor minuta je na kartici, kao i inače
        this.chooserId = t.id;
        this.focusKey("pick-" + this.settings.lastEst);
        return;
      }
      this.move(t.id, to);
    },
    menuFocusKey(menu) {
      return (menu.kind === "status" ? "sm-" : "more-") + menu.id;
    },
    closeMenu(returnFocus) {
      const m = this.menu;
      this.menu = null;
      this.confirmId = null;
      if (m && returnFocus) this.focusKey(this.menuFocusKey(m));
    },
    closeChooser(id) {
      this.chooserId = null;
      this.focusKey("go-" + id);
    },
    onMenuDetails(id) {
      this.closeMenu(false);
      this.openDetails(id);
    },
    onBackStep(id) {
      const t = this.byId(id);
      const to = t && backOf(t);
      if (to) this.move(id, to);
    },
    onHold(id) {
      this.move(id, "on-hold");
    },
    askReject(id) {
      this.confirmId = id;
      this.focusKey("rn");
    },
    rejectOrder(id) {
      this.move(id, "rejected");
    },
    cancelReject() {
      const id = this.menu && this.menu.id;
      this.closeMenu(false);
      if (id) this.focusKey("more-" + id);
    },

    // ---------- tastatura ----------
    // Escape zatvara redom: meni i iskakanja, list, izbor minuta, pretragu. / traži, Z poništava, S zvuk.
    // Na izabranoj kartici: Enter ili razmak = glavna radnja, M = meni, strelice = kretanje.
    onKey(e) {
      if (e.defaultPrevented || e.ctrlKey || e.metaKey || e.altKey) return;
      const k = e.key;
      const tg = e.target;
      const typing = !!tg && (/^(INPUT|TEXTAREA|SELECT)$/.test(tg.tagName) || tg.isContentEditable);
      if (k === "Escape") {
        if (this.pop || this.menu) {
          e.preventDefault();
          const was = this.menu && this.menuFocusKey(this.menu);
          this.pop = null;
          this.menu = null;
          this.confirmId = null;
          if (was) this.focusKey(was);
          return;
        }
        if (this.sheet) {
          e.preventDefault();
          this.closeSheet();
          return;
        }
        if (this.chooserId) {
          e.preventDefault();
          this.closeChooser(this.chooserId);
          return;
        }
        if (typing && tg.getAttribute("data-fk") === "q") {
          e.preventDefault();
          if (this.q) this.q = "";
          else {
            this.qOpen = false;
            this.focusKey("qb");
          }
        }
        return;
      }
      if (typing) return;
      if (k === "/") {
        e.preventDefault();
        this.openSearch();
        return;
      }
      if (k === "z" || k === "Z" || (k === "Backspace" && !this.sheet)) {
        if (this.undo) {
          e.preventDefault();
          this.undoLast();
        }
        return;
      }
      if (k === "s" || k === "S") {
        e.preventDefault();
        this.toggleSound();
        return;
      }
      const card = tg && tg.classList && tg.classList.contains("k2c") ? tg : null;
      if (!card) return;
      const id = Number(card.getAttribute("data-id"));
      if (k === "Enter" || k === " ") {
        e.preventDefault();
        const t = this.byId(id);
        if (t && actionOf(t)) this.go(id);
        else this.openDetails(id);
        return;
      }
      if (k === "m" || k === "M") {
        e.preventDefault();
        const btn = card.querySelector('[data-fk="more-' + id + '"]');
        if (btn) this.onMore(id, btn);
        return;
      }
      if (k === "ArrowDown" || k === "ArrowUp" || k === "ArrowLeft" || k === "ArrowRight") {
        e.preventDefault();
        const col = card.closest(".k2-colb");
        if (!col) return;
        const cards = Array.from(col.querySelectorAll(".k2c"));
        const i = cards.indexOf(card);
        let target = null;
        if (k === "ArrowDown") target = cards[i + 1];
        else if (k === "ArrowUp") target = cards[i - 1];
        else {
          const cols = Array.from(this.$el.querySelectorAll(".k2-colb")).filter((c) => c.querySelector(".k2c"));
          const next = cols[cols.indexOf(col) + (k === "ArrowRight" ? 1 : -1)];
          if (next) {
            const list = next.querySelectorAll(".k2c");
            target = list[Math.min(i, list.length - 1)];
          }
        }
        if (target) {
          target.focus({ preventScroll: true });
          target.scrollIntoView({ block: "nearest" });
        }
      }
    },
  },
};
</script>
